import React from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";

const PageWrapper = (props) => {
  const scrollHome = () => {
    setTimeout(() => {
      props.executeScroll();
    }, 200);
  };
  const scrollHomeubicacion = () => {
    setTimeout(() => {
      props.executeScrollubicacion();
    }, 200);
  };
  const scrollHomeamenidades = () => {
    setTimeout(() => {
      props.executeScrollamenidades();
    }, 200);
  };
  const scrollHomeinfraestructura = () => {
    setTimeout(() => {
      props.executeScrollinfraestructura();
    }, 200);
  };
  const scrollHomepropiedades = () => {
    setTimeout(() => {
      props.executeScrollpropiedades();
    }, 200);
  };
  const scrollHomedisponibilidad = () => {
    setTimeout(() => {
      props.executeScrolldisponibilidad();
    }, 200);
  };

  return (
    <React.Fragment>
      <Header
        backgroundImage={props.backgroundImage}
        btnState={props.btnState}
        handleClick={props.handleClick}
        executeScroll={scrollHome}
        executeScrollubicacion={scrollHomeubicacion}
        executeScrollamenidades={scrollHomeamenidades}
        executeScrollinfraestructura={scrollHomeinfraestructura}
        executeScrollpropiedades={scrollHomepropiedades}
        executeScrolldisponibilidad={scrollHomedisponibilidad}
        selectedOption={props.selectedOption}
      />
      {props.children}
      <Footer />
    </React.Fragment>
  );
};

export default PageWrapper;
